<template>
  <div ref="infinite-feed">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "infinite-feed",

  props: {
    enabled: Boolean,
  },

  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },

  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },

  methods: {
    handleScroll: async function () {
      if (!this.enabled) return;
      let bottom = this.$refs["infinite-feed"].getBoundingClientRect().bottom;

      if (bottom - 500 < window.innerHeight && this.enabled) {
        this.$emit("load-more");
      }
    },
  },
};
</script>
